module.exports = __webpack_public_path__ + "media/images/athletes/3307-bb54d3846dae45b321bc97e1067eb0a7.png";